import { newSpecPage } from '@stencil/core/testing';
import { HrWidget } from '../hr-widget';

describe('hr-widget', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [HrWidget],
      html: `<hr-widget></hr-widget>`,
    });
    expect(page.root).toEqualHtml(`
      <hr-widget>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </hr-widget>
    `);
  });
});
